export const searchOrganizations = (params: { search: string }) => `searchOrganizations:${params?.search}`;
export const getOrganizations = 'getOrganizations';
